// ─────────────────────────────────────────────────────────────────────────────
// FEATURE: Admin panel  (colour classes shared by the order screens)
// Kept out of AdminParts.tsx so that file only exports components (React fast refresh).
// Neighbours: pages/admin/AdminOrders, pages/admin/AdminCustomerDetail.
// ─────────────────────────────────────────────────────────────────────────────
import type { OrderStatus } from "../../utils/orders";

/** Status chip colours shared by the order screens (orders console, customer page). */
export const STATUS_PILL: Record<OrderStatus, string> = {
  placed: "bg-coral-500/15 text-coral-700 dark:text-coral-300",
  confirmed: "bg-ocean-700/10 text-ocean-900 dark:bg-white/10 dark:text-foam-100",
  preparing: "bg-ocean-700/15 text-ocean-900 dark:bg-white/15 dark:text-foam-100",
  out_for_delivery: "bg-ocean-800 text-white",
  delivered: "bg-teal-500/15 text-teal-800 dark:text-teal-300",
  cancelled: "bg-ocean-900/10 text-ocean-800/80 line-through dark:bg-white/10 dark:text-foam-100/70",
};
